import { Point } from "./Point";
export class GrahamScan {
    static scanPList(pList, out) {
        let len = Math.floor(pList.length / 2);
        _tmpPoints.length = len;
        if (len > _pointPool.length)
            _pointPool.length = len;
        for (let i = 0; i < len; i++) {
            let pt = _pointPool[i] || (_pointPool[i] = new Point());
            pt.setTo(pList[i + i], pList[i + i + 1]);
            _tmpPoints[i] = pt;
        }
        let res = GrahamScan.scan(_tmpPoints, _tmpPoints);
        out = out || [];
        out.length = 0;
        for (let i = 0, n = res.length; i < n; i++) {
            out.push(res[i].x, res[i].y);
        }
        return out;
    }
    static scan(points, out) {
        let pts = removeDuplicatePoints(points);
        let len = pts.length;
        let k = 0;
        for (let i = 1; i < len; i++) {
            if ((pts[i].y < pts[k].y) || ((pts[i].y == pts[k].y) && (pts[i].x < pts[k].x)))
                k = i;
        }
        let tmp = pts[0];
        pts[0] = pts[k];
        pts[k] = tmp;
        for (let i = 1; i < len - 1; i++) {
            k = i;
            for (let j = i + 1; j < len; j++) {
                if ((multiply(pts[j], pts[k], pts[0]) > 0) || ((multiply(pts[j], pts[k], pts[0]) == 0)
                    && (dis(pts[0], pts[j]) < dis(pts[0], pts[k]))))
                    k = j;
            }
            let tmp = pts[i];
            pts[i] = pts[k];
            pts[k] = tmp;
        }
        out = out || [];
        out.length = 0;
        if (pts.length < 3) {
            out.push(...pts);
            return out;
        }
        out.push(pts[0], pts[1], pts[2]);
        for (let i = 3; i < len; i++) {
            while (out.length >= 2 && multiply(pts[i], out[out.length - 1], out[out.length - 2]) >= 0)
                out.pop();
            out.push(pts[i]);
        }
        return out;
    }
}
const _tmpPoints = [];
const _tmpPoints2 = [];
const _pointPool = [];
const _test = new Set();
function removeDuplicatePoints(points) {
    _test.clear();
    _tmpPoints2.length = 0;
    for (let i = points.length - 1; i >= 0; i--) {
        let tmp = points[i];
        let key = tmp.x + "_" + tmp.y;
        if (!_test.has(key)) {
            _test.add(key);
            _tmpPoints2.push(tmp);
        }
    }
    return _tmpPoints2;
}
function multiply(p1, p2, p0) {
    return ((p1.x - p0.x) * (p2.y - p0.y) - (p2.x - p0.x) * (p1.y - p0.y));
}
function dis(p1, p2) {
    return (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y);
}
